import React from 'react';
import SelectSearch from './components/react-select-search';
import { Translation } from "react-i18next";
import PageSearchResult from "./PageSearchResult";



const categories_all_options = [
    {
        url: '/all',
        name: 'All',
        num: 12
    }
]

const new_collection_attribute_list = [
    {
        href: '/apps/alpa',
        imgsrc: 'https://api-cdn.zhink.cn/app%2F6154722_1_feoct7.png',
        category: 'AI',
        name: 'BioGPT',
        brand: 'GPT'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'https://api-cdn.zhink.cn/app%2Funnamed_3_ewef9y.png',
        category: 'AI',
        name: 'Bing Search + ChatGPT',
        brand: 'GPT'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'https://api-cdn.zhink.cn/app%2Fd69a2c7e-4594-4d3e-8919-4c47acf06cac_nlguwo.png',
        category: 'AI',
        name: 'ChatGPT Famous Resumes',
        brand: 'GPT'
    }
]

const all_collection_attribute_list = [
    {
        href: '/apps/alpa',
        imgsrc: 'https://res.cloudinary.com/apideck/image/upload/w_96,f_auto/v1672258078/marketplaces/ckhg56iu1mkpc0b66vj7fsj3o/listings/Screenshot_2022-12-28_at_21.07.32_jqgcal.png',
        category: 'GPT-3',
        name: 'Alpa',
        brand: 'GPT'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/05b4d853537494754bf3a30e31aa87a192c8639e7',
        category: 'Tools',
        name: 'AI绘画大师',
        brand: 'xiaomi'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'https://is3-ssl.mzstatic.com/image/thumb/Purple126/v4/f8/74/6e/f8746ebb-a181-3c46-fe97-ab12b8c00d52/AppIcon-0-1x_U007emarketing-0-0-0-6-0-0-sRGB-85-220.png/434x0w.webp',
        category: 'Tools',
        name: 'Google Chrome',
        brand: 'Google'
    },
    {
        href: '/apps/alpa',
        category: 'Tools',
        imgsrc: 'https://is3-ssl.mzstatic.com/image/thumb/Purple116/v4/63/9a/e7/639ae7cc-e5af-ae35-ad05-ba0fa1a00a16/AppIcon-0-1x_U007emarketing-0-0-0-6-0-0-sRGB-0-85-220-0.png/434x0w.webp',
        name: 'Microsoft Edge',
        brand: 'Microsoft'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/0bd26671147224491816a64ff9fc682dfa9eca108',
        category: 'Tools',
        name: 'AI写小说',
        brand: 'xiaomi'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/0511d906009864e118b7a3e95dfbae1393769d2cc',
        category: 'Tools',
        name: '智能AI助手',
        brand: 'xiaomi'
    },
    {
        href: '/apps/alpa',
        imgsrc: 'http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/0689bfad7bcb442bb9d9b8a7ac902b931e81ebd3f',
        category: 'Tools',
        name: 'AI剪映',
        brand: 'xiaomi'
    },
    {
        href: '/apps/alpa',
        category: 'Tools',
        imgsrc: 'https://is5-ssl.mzstatic.com/image/thumb/Purple116/v4/be/bb/e5/bebbe5dc-12ba-b67b-5c7b-78148d39f6c6/AppIcon-1x_U007emarketing-0-7-0-85-220.png/434x0w.webp',
        name: '算法宝',
        brand: 'Apple'
    },
]

const search_result_data_list = [
    {
      title: "australia.cn",
      cite_url: "https://www.australia.cn",
      detail_url: "https://www.australia.cn/zh-cn/explore.html",
      content: "澳大利亚旅游官网为您开启一场独特的出境探索之旅。 计划你的行程，了解目的地信息，更多澳大利亚旅游资讯，请访问澳大利亚旅游局官方网站australia.cn。",
      brand: "Apple",
      breif_content: "探索及计划行程 – 澳大利亚旅游局"
    },
  ];

// function getOptions(query) {
//     return new Promise((resolve, reject) => {
//         fetch(`https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${query}`)
//             .then(response => response.json())
//             .then(({ drinks }) => {
//                 resolve(drinks.map(({ idDrink, strDrink }) => ({ value: idDrink, name: strDrink })))
//             })
//             .catch(reject);
//     });
// }
class PageBody extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            renderValue: false,
            options: [
                {
                    name: 'HuaWei',
                    value: 'sv',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                },
                {
                    name: 'Xiaomi',
                    value: 'qe',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                },
                {
                    name: 'Apple',
                    value: 'br',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                },
                {
                    name: 'Sangsung',
                    value: 'we',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                },
                {
                    name: 'GPT',
                    value: 'aad',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                },
                {
                    name: 'AGV',
                    value: 'wef',
                    url: 'https://api-cdn.zhink.cn/logo1.png'
                }
            ]
        }
    }
    collapseRenderValue = () => {
        this.setState({
            renderValue: !this.state.renderValue
        })
    }
    render() {
        return (
            <div className="page-body">
                <div className="max-width-container">
                    <div className="page-container">
                        <aside >
                            <div className="sidebar">
                                <div className="sidebar-content">
                                    <div className="google-auto-placed"
                                        style={{ "width": "100%", "height": "auto", "clear": "both", "textAlign": "center" }}>
                                        {/* <h4><a className="" data-testid="section-link-categories" href="/categories/all">
                                            <Translation>
                                                {(t) => <span className="post-fix">{t("home.menu-categories")}</span>}
                                            </Translation>
                                        </a></h4> */}
                                        {/* <ul>
                                            {
                                                categories_all_options.map((item, idx) => (
                                                    <li key={item} data-testid="sidebar-item-all"><a href={item.url}><span> {item.name}</span>
                                                        <div className="count-badge">{item.num}</div>
                                                    </a></li>
                                                ))
                                            }
                                        </ul> */}
                                    </div>
                                    <div className="sidebar-section category-menu-section">
                                        <Translation>
                                            {(t) => <h4 className="post-fix">{t("home.menu-tips-first")}</h4>}
                                        </Translation>
                                        <Translation>
                                            {(t) => <div className="sidebar-section">{t("home.menu-tips-sec")}</div>}
                                        </Translation>
                                        <Translation>
                                            {(t) => <button className="button ib">{t("home.menu-tips-button")}</button>}
                                        </Translation>
                                    </div>
                                </div>
                                <div className="mobile-buttons" data-testid="mobile-buttons">
                                    <div className="products">
                                        <h4>Products</h4><span><svg stroke="currentColor" fill="currentColor"
                                            strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                                        </svg></span>
                                    </div>
                                    <div className="collections">
                                        <h4>Collections</h4><span><svg stroke="currentColor" fill="currentColor"
                                            strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                                        </svg></span>
                                    </div>
                                    <div className="categories">
                                        <Translation>
                                            {(t) => <h4 className="post-fix">| {t("home.tips-first")}</h4>}
                                        </Translation>
                                        <span><svg stroke="currentColor" fill="currentColor"
                                            strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"></path>
                                        </svg></span>
                                    </div>
                                </div>
                            </div>
                        </aside>

                        <PageSearchResult
                            name="search area app"
                            attribute={search_result_data_list}
                            />                        
                    </div>
                </div>
            </div>
        )
    }
}

export default PageBody;
